
import { defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { WALL_SCREENS, disableWall, wallState } from '@/utils/wall'

export default defineComponent({
  name: 'ScreenNav',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const exitWall = () => {
      disableWall()
      router.push('/')
    }
    return { route, screens: WALL_SCREENS, wallState, exitWall }
  },
})
